
/* eslint-disable */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
	mdiRunFast,
	mdiAccountDetails,
	mdiAccountAlert,
	mdiBusDoubleDecker,
	mdiOfficeBuilding,
	mdiAccountConvert,
	mdiCalendar,
	mdiSoccer,
	mdiAccountSchool,
	mdiCog,
	mdiAccount,
	mdiSchool,
	mdiExclamationThick,
	mdiPencilOff,
	mdiComment,
	mdiGoogleClassroom,
	mdiBookshelf,
	mdiCashMultiple,
	mdiFlag,
	mdiCalendarAccount,
	mdiNeedle,
	mdiArrowUpBold,
	mdiAccountCircle,
	mdiBookOpenVariant,
	mdiFaceAgent,
	mdiAccountGroup,
	mdiCalendarCursor,
	mdiClipboardAccount,
	mdiClipboardAccountOutline,
	mdiNotebookMultiple,
	mdiAccountArrowLeft,
	mdiAccountArrowLeftOutline,
	mdiCalendarMonth,
	mdiBookOpenPageVariant,
	mdiBookEducationOutline,
	mdiHammerScrewdriver,
	mdiBookPlusMultiple,
	mdiFormatLetterMatches,
	mdiFormatListBulletedType,
	mdiCurrencyUsd,
	mdiNotebookEdit,
	mdiNumeric9BoxMultiple,
	mdiWatermark,
	mdiAccountMultiplePlus,
	mdiPen,
	mdiChartBar,
	mdiTagMultiple,
	mdiViewModule,
	mdiTrophyOutline
} from '@mdi/js'

const menuCourseAll = [
	'Examples',
		[
			{
				label: 'Master',
				subLabel: 'Submenus Master',
				icon: mdiCog,
				menu: [
					{
						to: '/academicyear',
						label: 'Academic Year',
						icon: mdiCalendar
					},
					{
						to: '/financialyear',
						label: 'Financial Year',
						icon: mdiCalendarMonth
					},
					{
						to: '/academicbatch',
						label: 'Academic Batch',
						icon: mdiCalendarAccount
					},
					{
						to: '/department',
						label: 'Department',
						icon: mdiOfficeBuilding
					},
					{
						to: '/semester',
						label: 'Batch',
						icon: mdiFlag
					},
					{
						to: '/level',
						label: 'Level',
						icon: mdiArrowUpBold
					},
					{
						to: '/resignationreason',
						label: 'Resignation Reason',
						icon: mdiBookOpenVariant
					},
					{
						to: '/class',
						label: 'Class',
						icon: mdiGoogleClassroom,
						updateMark: true
					},
					{
					  to: '/workunit',
					  label: 'Work Unit',
					  icon: mdiOfficeBuilding,
					  updateMark: true
					},
					{
					  to: '/shift',
					  label: 'Shift',
					  icon: mdiAccountConvert,
					  updateMark: true
					},
					// {
					// 	to: '/extracuricular',
					// 	label: 'Extracuricular',
					// 	icon: mdiSoccer
					// },
					{
						to: '/vaccines',
						label: 'Vaccines',
						icon: mdiNeedle
					},
					{
						to: '/comment',
						label: 'Comment',
						icon: mdiComment
					},
					{
						to: '/regisbatch',
						label: 'Registration Batch',
						icon: mdiCalendarCursor
					},
					{
						to: '/major',
						label: 'Major',
						icon: mdiSchool
					},
					{
						to: '/major-date',
						label: 'Event',
						icon: mdiSchool
					},
					{
						to: '/violation',
						label: 'Violation',
						icon: mdiExclamationThick
					},
					{
						to: '/punishment',
						label: 'Punishment',
						icon: mdiPencilOff
					}
				]
			},

			{
				label: 'Master Course',
				subLabel: 'Coursework Master',
				icon: mdiViewModule,
				menu: [
					{
						to: '/coursework',
						label: 'Coursework',
						icon: mdiBookEducationOutline
					},
					{
						to: '/price-group',
						label: 'Price Group',
						icon: mdiTagMultiple
					},
					// {
					// 	to: '/price-list',
					// 	label: 'Price List',
					// 	icon: mdiCurrencyUsd
					// },
					{
						to: '/non-academic-activity',
						label: 'Non Academic Activity',
						icon: mdiRunFast
					}
				]
			},
			{
				label: 'Course Achievement',
				to: '/coursework-achievement',
				icon: mdiTrophyOutline
			},
			{
				label: 'Student',
				subLabel: 'Submenus Student',
				icon: mdiAccountCircle,
				menu: [
					{
						to: '/students',
						label: 'Students Data',
						icon: mdiAccountGroup
					},
					{
						to: '/class-transfer',
						label: 'Class Transfer',
						icon: mdiAccountMultiplePlus
					},
					{
						to: '/studentresignation',
						label: 'Resignation',
						icon: mdiAccountGroup
					},
					{
						to: '/graduation',
						label: 'Graduation',
						icon: mdiAccountSchool
					}
				]
			},
			{
				label: 'Parents',
				to: '/parentuser',
				icon: mdiAccount
			},
			{
				label: 'Employee',
				subLabel: 'Employee',
				icon: mdiAccountCircle,
				menu: [
					{
						to: '/employee',
						label: 'Employees',
						icon: mdiAccount
					}
				]
			},
			{
				label: 'Subject',
				subLabel: 'Submenus Subject',
				icon: mdiBookOpenVariant,
				menu: [
					{
						to: '/subject',
						label: 'Subject',
						icon: mdiBookshelf
					},
					{
						to: '/subjectgroup',
						label: 'Subject Group',
						icon: mdiBookOpenPageVariant
					},
					{
						to: '/learningmethod',
						label: 'Learning Method',
						icon: mdiBookPlusMultiple
					},
					{
						to: '/gradingaspects',
						label: 'Grading Aspects',
						icon: mdiHammerScrewdriver
					},
					{
						to: '/assignmenttype',
						label: 'Assignment Type',
						icon: mdiFormatListBulletedType
					},
					{
						to: '/grading-rule',
						label: 'Grading Rule',
						icon: mdiFormatLetterMatches
					},
					{
						to: '/finalscorerule',
						label: 'Final Score Rule',
						icon: mdiNumeric9BoxMultiple
					},
					{
						to: '/scoreminimum',
						label: 'Passing Grade',
						icon: mdiNumeric9BoxMultiple
					},
					{
						to: '/syllabus',
						label: 'Syllabus',
						icon: mdiNotebookEdit
					},
					{
						to: '/studentselectsubject',
						label: 'Student Subject Selection',
						icon: mdiAccountDetails
					}
				]
			},
			{
				label: 'Extracuricular',
				subLabel: 'Submenus Extracuricular',
				icon: mdiSoccer,
				menu: [
					{
						to: '/extracuricular',
						label: 'Extracuricular',
						icon: mdiSoccer
					},
					{
						to: '/extracuriculagroup',
						label: 'Extracuricular Group',
						icon: mdiSoccer
					},
					{
						to: '/extracuricularstudent',
						label: 'Student Extracuricular',
						icon: mdiAccountDetails
					},
					{
						to: '/extracuricularstudentselect',
						label: 'Student Extracuricular Selection',
						icon: mdiAccountDetails
					}
					// {
					// 	to: '/extracuricularbarchart',
					// 	label: 'Report Extracuricular',
					// 	icon: mdiAccountDetails
					// }
				]
			},
			{
				label: 'Teacher',
				subLabel: 'Submenus Teacher',
				icon: mdiClipboardAccount,
				menu: [
					{
						to: '/teacher',
						label: 'Teacher',
						icon: mdiClipboardAccountOutline
					},
					{
						to: '/coursework-teacher',
						label: 'Coursework',
						icon: mdiNotebookMultiple
					}
				]
			},
			{
				label: 'Roles',
				subLabel: 'Roles',
				icon: mdiFaceAgent,
				menu: [
					{
						to: '/role',
						label: 'Role',
						icon: mdiFaceAgent
					},
					{
						to: '/role-group',
						label: 'Role Group',
						icon: mdiFaceAgent
					}
				]
			},
			{
				label: 'Transaction',
				subLabel: 'Transaction',
				icon: mdiCashMultiple,
				menu: [
					{
						to: '/transaction-type',
						label: 'Transaction Type',
						icon: mdiCashMultiple
					},
					{
						to: '/transaction-group',
						label: 'Transaction Group',
						icon: mdiCashMultiple
					}
				]
			},
			{
				label: 'Permission Request',
				subLabel: 'Submenus Teacher',
				icon: mdiFaceAgent,
				menu: [
					{
						to: '/permissions',
						label: 'Permissions',
						icon: mdiFaceAgent
					},
         			{
						to: '/permission-reason',
						label: 'Permission Reason',
						icon: mdiFaceAgent
					}
				]
			},
			{
				label: 'Attendance',
				subLabel: 'Submenus Attendance',
				icon: mdiAccountArrowLeft,
				menu: [
					{
						to: '/attendancelist',
						label: 'Regular Subject',
						icon: mdiAccountArrowLeftOutline
					},
					{
						to: '/reportattendancedaily',
						label: 'Daily Attendance Report',
						icon: mdiAccountAlert
					},
					{
						to: '/summary-report',
						label: 'Summary Report',
						icon: mdiAccountAlert
					},
					{
						to: '/assignment-special',
						label: 'Special Assignment',
						icon: mdiBusDoubleDecker
					}
				]
			},
			{
				label: 'Subject Assessment',
				subLabel: 'Submenus Subject Assessment',
				icon: mdiSchool,
				menu: [
					{
						to: '/lesson-assessment-regular',
						label: 'Regular',
						icon: mdiSchool
					},
					{
						to: '/ledger-homeroom-teacher',
						label: 'Homeroom Ledger',
						icon: mdiSchool
					},
					{
						to: '/extracuricular-score',
						label: 'Extracuricular Score',
						icon: mdiSchool
					}
				]
			},
			{
				label: 'Settings',
				subLabel: 'Submenus Settings',
				icon: mdiCog,
				menu: [
					{
						to: '/schoolidentity',
						label: 'School Identity',
						icon: mdiSchool
					},
					{
						to: '/branch',
						label: 'Branch',
						icon: mdiWatermark
					},
					{
						to: '/users',
						label: 'Users',
						icon: mdiAccount
					},
					{
						to: '/settingattendance',
						label: 'Setting Attendance',
						icon: mdiPen
					},
					{
						to: '/settingspeed',
						label: 'Chart & Analysis Setting',
						icon: mdiChartBar
					},
					{
						to: '/template-announcement',
						label: 'Template Announcement',
						icon: mdiSchool
					}
				]
			}
		]
]
export default menuCourseAll
